import "./Footer.css";
import DownloadPlatform from "./DownloadPlatform";

const Footer = ({ disappearPlatform }) => {
  return (
    <section className="footer">
      <div className="divcontainer">
        {disappearPlatform ? null : <DownloadPlatform />}
        <footer className="divrow4">
          <div className="footer-top">
            <div className="logo">
              <div className="logo-title-frame">
                <img className="project-logo" alt="" src="/project-logo.png" />
                <h3 className="project-name">Forex Miner</h3>
              </div>
              <div className="our-platform-offers-container">
                Our platform offers users an exclusive subscription-based access
                to trading bot, providing a personalized and efficient
                experience. Subscribers can harness the power of our AI bot to
                simplify tasks, answer queries, and enhance their overall online
                journey.Join us on the journey of innovation and convenience.
                Subscribe today and elevate your digital interactions with Forex
                Miner.
              </div>
            </div>
            <div className="links">
              <h3 className="links1">Links</h3>
              <div className="items1">
                <div className="follow-these-helpful-container">
                  <p>
                    Follow these helpful resources to get up to date information
                    on Forex Miner.
                  </p>
                  <div className="item24">
                    <div className="divicon-parent">
                      <div className="divicon7">
                        <div className="security-icon-frame1">
                          <img
                            className="foundationsocial-facebook-icon"
                            alt=""
                            src="/foundationsocialfacebook.svg"
                          />
                        </div>
                      </div>
                      <div className="heading-44">Facebook</div>
                    </div>
                  </div>
                  <div className="item24">
                    <div className="divicon-parent">
                      <div className="divicon7">
                        <div className="security-icon-frame1">
                          <img
                            className="foundationsocial-linkedin-icon"
                            alt=""
                            src="/foundationsociallinkedin.svg"
                          />
                        </div>
                      </div>
                      <div className="heading-44">Linkedin</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="copyright-div">
          Copyright 2024 @ Forex Miner.All rights reserved.
        </div>
      </div>
    </section>
  );
};

export default Footer;
